import { AWS_API_URL } from 'global/environment';
import { authorize, putRequest } from 'utils/http';
import { mapTimeProfilesToSchedules } from '../mapData';

export async function updateTimeProfilesAPI(id, timeProfile) {
  const url = `${AWS_API_URL}/2n/time-profiles/${id}`;
  const payloadSchedules = timeProfile && Array.isArray(timeProfile.timeProfiles)
    ? mapTimeProfilesToSchedules(timeProfile.timeProfiles)
    : {};

  return putRequest(url, {
    data: {
      Name: timeProfile && timeProfile.name,
      ...payloadSchedules,
    },
  }, await authorize());
}
